import React from 'react';
import styled, { css } from 'styled-components';
import tinycolor from 'tinycolor2';
import Text from '../basic/Text';
import withTheme from '../../utils/styles/theme/withTheme';
import Button from '../basic/Button';

const Layout = styled.div`
  height: 100vh;
  display: flex;
  font-family: -apple-system, BlinkMacSystemFont, Roboto, 'Segoe UI', 'Fira Sans', Avenir,
    'Helvetica Neue', 'Lucida Grande', sans-serif;
  align-items: center;
  justify-content: center;
`;

const Error = styled.div`
  display: flex;
  flex-direction: row;
`;

const ErrorCode = styled.h1`
  border-right: 1px solid
    ${({ theme: { colors } }) =>
      tinycolor(colors.dark.primary)
        .setAlpha(0.3)
        .toString()};
  margin-right: 20px;
  padding: 10px 23px 10px 0;
  font-size: 24px;
  font-weight: 500;
  vertical-align: top;
`;

const ErrorMessage = styled.div``;

const ErrorClientSidePage = ({ onReportError }) => {
  return (
    <Layout>
      <Error>
        <Text>
          <ErrorCode>500</ErrorCode>
        </Text>
        <ErrorMessage>
          <Text>
            <h2>Oops! Something went wrong.</h2>
          </Text>
          <p>
            <Button type="primary" onClick={onReportError}>
              <Text>Report this error</Text>
            </Button>
          </p>
          <p>
            <a
              href="#"
              onClick={() => {
                window.location.reload(true);
              }}
            >
              <Text>Or, try reloading the page</Text>
            </a>
          </p>
        </ErrorMessage>
      </Error>
    </Layout>
  );
};

export default withTheme(ErrorClientSidePage);
